export enum FontTShirtSize {
  xxs = 'var(--typography-body3)',
  xs = 'var(--typography-body5)',
  sm = 'var(--typography-body2)',
  md = 'var(--typography-body1)',
  lg = 'var(--typography-headline)'
}
